module.exports = __webpack_public_path__ + "img/direction-left-right.9ba83b8a.svg";